module.exports = __webpack_public_path__ + "0cd3cf7f814843f752f0b5af44a4c44d.jpg";